module.exports = __webpack_public_path__ + "img/403.d145c6b5.svg";